if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.syncExternalQuantityInput();
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.submitButton.hasAttribute('disabled'))
          return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const selectedVariant = this.selectedVariant;

        if (selectedVariant) {
          const parsedVariant = JSON.parse(selectedVariant);
          if (parsedVariant?.id) {
            this.variantIdInput.value = parsedVariant.id;
          }
        }

        this.syncQuantityField();
        const formData = new FormData(this.form);
        const quantityInput = this.quantityInput;

        if (quantityInput?.value) {
          formData.set('quantity', quantityInput.value);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              } catch (error) {
                // A non-critical subscriber must never block rendering the cart after a successful add.
                console.error('Cart update subscriber failed:', error);
              }
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.renderCartContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.renderCartContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      renderCartContents(response) {
        try {
          this.cart.renderContents(response);
        } catch (error) {
          // The item has already been added. Never leave the customer with a stale cart UI.
          console.error('Cart rendering failed after add:', error);
          window.location.assign(window.routes.cart_url);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      get productInfo() {
        return this.closest('product-info');
      }

      get selectedVariant() {
        return this.productInfo?.querySelector('variant-selects [data-selected-variant]')?.textContent;
      }

      get quantityInput() {
        return (
          this.productInfo?.querySelector(`.product-form__quantity .quantity__input[form="${this.form.id}"]`) ||
          this.productInfo?.querySelector('.product-form__quantity .quantity__input')
        );
      }

      get formQuantityInput() {
        let input = this.form.querySelector('input[name="quantity"]');

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          this.form.appendChild(input);
        }

        return input;
      }

      syncExternalQuantityInput() {
        this.quantityInput?.addEventListener('input', this.syncQuantityField.bind(this));
        this.quantityInput?.addEventListener('change', this.syncQuantityField.bind(this));
        this.syncQuantityField();
      }

      syncQuantityField() {
        if (!this.quantityInput) return;

        this.formQuantityInput.value = this.quantityInput.value;
      }
    }
  );
}
